import React from "react";
import {
  backColorModal,
  foreColorCodePagination,
} from "../../../commons/colors";
import { Modal } from "@mui/material";
import { useRecoilState, useRecoilValue } from "recoil";
import classes from "./SetDetailModal.module.scss";
import CancelIcon from "@mui/icons-material/Cancel";
import SearchIcon from "@mui/icons-material/Search";
import {
  drawingNamesState,
  productItemsState,
  userState,
} from "../../../states/userState";
import FactorySelector from "../molecules/FactorySelector";
import CreateDocumentTags from "../molecules/CreateDocumentTags";
import CreateDrawingTags from "../molecules/CreateDrawingTags";
import ProductItemsSelector from "../molecules/productItemsSelector/ProductItemsSelector";
import { CustomIconButton } from "../atoms/buttons/IconButton";
import useFetchDrafts from "../../../hooks/useFetchDrafts";

const SetDetailParams = (props) => {
  const { isShow, setIsShow, setKintoneArray } = props;
  const user = useRecoilValue(userState);
  const { fetchDraftsByEnterKey } = useFetchDrafts();

  return (
    <Modal
      open={isShow}
      onClose={() => setIsShow(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        borderColor: "prmary.main",
        "&:focus-visible": {
          borderColor: "prmary.main",
          outlineColor: foreColorCodePagination(user?.mode ?? "dart"), // Assuming your theme's primary.main is the color you want
        },
      }}
    >
      <div
        className={classes.root}
        style={backColorModal(user?.mode ?? "lite")}
      >
        <div className={classes.actionButtons}>
          <CustomIconButton
            icon={CancelIcon}
            placement={"left"}
            disabled={false}
            onClick={() => setIsShow(false)}
            caption={"閉じる"}
          />
          <CustomIconButton
            icon={SearchIcon}
            disabled={false}
            onClick={async () => {
              setIsShow(false);
              const res = await fetchDraftsByEnterKey();
              setKintoneArray(res);
            }}
            caption={"検索実行"}
          />
        </div>
        <div className={classes.firstContainer}>
          <FactorySelector />
          <div>
            <CreateDocumentTags />
            <CreateDrawingTags />
          </div>
        </div>
        <ProductItemsSelector />
      </div>
    </Modal>
  );
};

export default SetDetailParams;
